// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"8e6d1a1f","247":"62ee4e19","627":"d7d089fb","834":"fe4bc9f5","867":"73bc472e","923":"34aaae51","938":"996d1747"}[chunkId] + ".chunk.js";
};